(function () {
  'use strict';
  var routes = window.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---------- scroll lock ----------
     `body { overflow: hidden }` does NOT stop scrolling on iOS Safari: the page
     keeps moving behind the drawer, and because that scrolling resizes Safari's
     toolbars the fixed drawer also stops covering the screen (you see the site
     above and below it). Pinning the body with position:fixed at a negative top
     genuinely freezes the page; the offset is restored on release. */
  var locks = 0;
  var savedScrollY = 0;
  function lock() {
    locks++;
    if (locks > 1) return;
    savedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
    var b = document.body;
    b.style.position = 'fixed';
    b.style.top = (-savedScrollY) + 'px';
    b.style.left = '0';
    b.style.right = '0';
    b.style.width = '100%';
    b.style.overflow = 'hidden';
  }
  function unlock() {
    locks = Math.max(0, locks - 1);
    if (locks) return;
    var b = document.body;
    b.style.position = '';
    b.style.top = '';
    b.style.left = '';
    b.style.right = '';
    b.style.width = '';
    b.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }

  /* ---------- mobile menu ---------- */
  var menu = $('[data-mobile-menu]');
  var scrim = $('[data-scrim]');
  function openMenu() { if (!menu) return; menu.classList.add('open'); if (scrim) scrim.classList.add('show'); lock(); }
  function closeMenu() { if (!menu) return; menu.classList.remove('open'); if (scrim) scrim.classList.remove('show'); unlock(); }
  $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', openMenu); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', closeMenu); });
  if (scrim) scrim.addEventListener('click', closeMenu);

  /* ---------- cart drawer ---------- */
  var drawer = $('[data-cart-drawer]');
  function openCart() {
    if (!drawer || drawer.classList.contains('open')) return;
    drawer.classList.add('open'); drawer.setAttribute('aria-hidden', 'false');
    var o = $('.cart-overlay'); if (o) o.classList.add('open'); lock();
  }
  function closeCart() {
    if (!drawer || !drawer.classList.contains('open')) return;
    drawer.classList.remove('open'); drawer.setAttribute('aria-hidden', 'true');
    var o = $('.cart-overlay'); if (o) o.classList.remove('open'); unlock();
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); }
    else if (e.target.closest('[data-cart-close]')) { closeCart(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeCart(); closeMenu(); closeSearch(); }
  });

  function setCartCount(n) { $$('[data-cart-count]').forEach(function (el) { el.textContent = n; }); }

  function refreshCartDrawer() {
    return fetch(routes.cart_url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer]');
        if (fresh && drawer) drawer.innerHTML = fresh.innerHTML;
        return fetch(routes.cart_url + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) setCartCount(cart.item_count); });
  }

  function addToCart(id, qty) {
    return fetch(routes.cart_add_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: id, quantity: qty || 1 })
    }).then(function (r) { return r.json(); });
  }

  function changeCart(key, qty) {
    return fetch(routes.cart_change_url + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* product form add */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();
    var idInput = form.querySelector('[name="id"]');
    var qtyInput = form.querySelector('[name="quantity"]');
    if (!idInput || !idInput.value) return;
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.classList.add('is-loading'); btn.disabled = true; }
    addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value, 10) : 1)
      .then(function () { return refreshCartDrawer(); })
      .then(function () { openCart(); })
      .finally(function () { if (btn) { btn.classList.remove('is-loading'); btn.disabled = false; } });
  });

  /* cart drawer qty / remove */
  document.addEventListener('click', function (e) {
    var item = e.target.closest('[data-cart-item]');
    if (!item) return;
    var key = item.getAttribute('data-key');
    var qtyEl = item.querySelector('[data-qty]');
    var qty = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    if (e.target.closest('[data-qty-up]')) { changeCart(key, qty + 1).then(refreshCartDrawer); }
    else if (e.target.closest('[data-qty-down]')) { changeCart(key, Math.max(0, qty - 1)).then(refreshCartDrawer); }
    else if (e.target.closest('[data-cart-remove]')) { changeCart(key, 0).then(refreshCartDrawer); }
  });

  /* ---------- search modal ---------- */
  var searchModal = $('[data-search-modal]');
  function openSearch() { if (!searchModal) return; searchModal.classList.add('open'); var o = $('.search-overlay'); if (o) o.classList.add('show'); lock(); var i = $('[data-search-input]'); if (i) setTimeout(function () { i.focus(); }, 50); }
  function closeSearch() { if (!searchModal) return; searchModal.classList.remove('open'); var o = $('.search-overlay'); if (o) o.classList.remove('show'); unlock(); }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    else if (e.target.closest('[data-search-close]')) { closeSearch(); }
  });
  var searchInput = $('[data-search-input]');
  var searchResults = $('[data-search-results]');
  var searchEmpty = $('[data-search-empty]');
  var st;
  if (searchInput) searchInput.addEventListener('input', function () {
    clearTimeout(st);
    var q = searchInput.value.trim();
    if (q.length < 2) { if (searchResults) searchResults.innerHTML = ''; if (searchEmpty) searchEmpty.hidden = true; return; }
    st = setTimeout(function () {
      var url = (routes.predictive_search_url || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!searchResults) return;
        if (!items.length) { searchResults.innerHTML = ''; if (searchEmpty) searchEmpty.hidden = false; return; }
        if (searchEmpty) searchEmpty.hidden = true;
        searchResults.innerHTML = items.map(function (p) {
          var img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '" alt="">' : '';
          return '<a class="search-result" href="' + p.url + '">' + img + '<span class="sr-name">' + p.title + '</span><span class="sr-price">' + p.price + '</span></a>';
        }).join('');
      });
    }, 220);
  });

  /* ---------- escape closes overlays ---------- */
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); closeMenu(); closeSearch(); } });

  /* ---------- carousels with dots ---------- */
  $$('[data-carousel]').forEach(function (root) {
    var track = root.querySelector('[data-carousel-track]');
    var dotsWrap = root.querySelector('[data-carousel-dots]');
    if (!track || !dotsWrap) return;
    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;
    slides.forEach(function (_, i) {
      var d = document.createElement('button');
      d.className = 'carousel-dot';
      d.type = 'button';
      d.setAttribute('aria-label', 'Go to slide ' + (i + 1));
      d.addEventListener('click', function () { slides[i].scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' }); });
      dotsWrap.appendChild(d);
    });
    var dots = $$('.carousel-dot', dotsWrap);
    track.addEventListener('scroll', function () {
      var idx = Math.round(track.scrollLeft / (track.scrollWidth / slides.length));
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }, { passive: true });
    if (dots[0]) dots[0].classList.add('active');
  });

  /* ---------- accordions ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.pdp-acc-q, .faq-q');
    if (!btn) return;
    var item = btn.closest('.pdp-acc-item, .faq-item');
    if (item) item.classList.toggle('open');
  });

  /* ---------- PDP: variant gallery + buy box ---------- */
  $$('[data-product]').forEach(function (root) {
    var mainImg = root.querySelector('[data-main-image]');
    root.addEventListener('click', function (e) {
      var thumb = e.target.closest('[data-thumb]');
      if (thumb && mainImg) {
        $$('[data-thumb]', root).forEach(function (t) { t.classList.remove('active'); });
        thumb.classList.add('active');
        var full = thumb.getAttribute('data-full');
        if (full) mainImg.src = full;
      }
    });
  });

  /* ---------- sticky ATC (PDP) ---------- */
  var sticky = $('[data-sticky-atc]');
  var atcAnchor = $('[data-atc-anchor]');
  if (sticky && atcAnchor && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -200px 0px' }).observe(atcAnchor);
  }

  /* ---------- wishlist count ---------- */
  try {
    var wl = JSON.parse(localStorage.getItem('cw_wishlist') || '[]');
    $$('[data-wish-count]').forEach(function (el) { el.textContent = wl.length; });
  } catch (e) {}

  /* ---------- scroll reveal ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$('[data-reveal]').forEach(function (el) { io.observe(el); });
  }
})();
